import { Box } from '@modusign/design-system';
import PropTypes from 'prop-types';

import RootLoadingSpinner from '@app/containers/Loading/RootLoadingSpinner';
import { RootModal } from '@app/containers/Modal';

const propTypes = {
  children: PropTypes.element.isRequired,
};

const RootLayout = ({ children }) => (
  <Box height="100%">
    <RootModal />
    <RootLoadingSpinner />
    <Box height="100%">{children}</Box>
  </Box>
);

RootLayout.propTypes = propTypes;

export default RootLayout;
